import styled from 'styled-components';
import colors from '../../../../config/colors.json';

export const Card = styled.div`
    border-radius: 8px;
    border: 1px solid ${colors.lightGrey9};
    background-size: transparent;
    opacity: 1;
    padding: 15px;
    > :last-child{
        border: none;
        padding-bottom: 0px;
    }
`;

export const CardRow = styled.div`
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${colors.lightGrey9};
`;

export const SummaryValue = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${colors.darkGrey};
    text-transform: capitalize;
    &.red {
        color: ${colors.lightRed};
    }
`;

export const StyledLink = styled.span`
    color: ${colors.red};
    text-decoration: underline;
    cursor: pointer;
`;

export const CloseModalSpan = styled.span`
    color: ${colors.darkGrey};
    font-size: 43px;
    font: Poppins;
    position: absolute;
    left: calc(100% - 50px);
    top: 10px;
    cursor: pointer;
`;
